import { Flex, Grid, Image, Switch, Text } from '@chakra-ui/react'
import { useEffect, useState } from 'react'
import { FaPen } from 'react-icons/fa'
import { useLocation, useNavigate } from 'react-router-dom'
import { Button } from '../../../../components/Button'
import { WhiteBox } from '../../../../components/WhiteBox'
import { appApi } from '../../../../services/appApi'
import { parseJwt } from '../../../../services/token'
import { Body } from '../../../Layouts/Body'
import { AcaoCard } from './Components/Acao'
import { ModalFinalizarAcao } from './Components/ModalFinalizarAcao'
import { ModalVisualizarComentarios } from './Components/ModalVisualizarComentarios'
import { Tabela } from './Components/Tabela'
import { OutlineContainer } from './styles'

interface iDadoTabela {
  id: string
  origem: string
  totalAcoes: number
  totalAcoesRealizadas: number
  dataInicio: string
  dataFim: string
  ultimaAvaliacao?: number
  status: number
  temAcaoAtrasada: boolean
}

interface iAcao {
  id: string
  assunto: string
  titulo: string
  descricao: string
  dataEntrega: string
  tempoDedicacao: number
  status: number
  dataInicio: string
  comentario?: string
}

interface iPDI {
  id: string
  origem: string
  acoes: iAcao[]
}

interface iModel {
  pdIs: iPDI[]
  tabela: iDadoTabela[]
}

interface iModalFializar {
  pdiId: string
  acao: iAcao
}

export const DashboardIndividualPDI: React.FC = () => {
  const { adm, role } = parseJwt()
  const [ModalVisualizarIsOpen, setModalVisualizarIsOpen] = useState(false)
  const [ModalFinalizarAcaoIsOpen, setModalFinalizarAcaoIsOpen] = useState(false)
  const [Model, setModel] = useState<iModel>()

  const [IsLoading, setIsLoading] = useState(false)

  const [Acao, setAcao] = useState<iModalFializar>()
  const { pathname } = useLocation()
  const nav = useNavigate()

  function onOpenModalVisualizarComentario(id: string, acao: iAcao): void {
    setModalVisualizarIsOpen(true)
    setAcao({ ...Acao, acao: acao, pdiId: id })
  }

  function onCloseModalVisualizarComentario(): void {
    setAcao(undefined)
    setModalVisualizarIsOpen(false)
  }

  function onOpenModalFinalizarAcao(id: string, acao: iAcao): void {
    setAcao({ ...Acao, acao: acao, pdiId: id })
    setModalFinalizarAcaoIsOpen(true)
  }

  function onCloseModalFinalizarAcao(): void {
    setAcao(undefined)
    setModalFinalizarAcaoIsOpen(false)
  }

  function ObterPDIs(): void {
    setIsLoading(true)
    appApi.get('PDI/Dashboard/Individual')
      .then(res => {
        setModel(res.data)
        setIsLoading(false)
      })
      .catch(err => console.log(err))
  }

  function FinalizarAcao(pdiId: string, acaoId: string, comentario: string): void {
    appApi.post(`PDI/${pdiId}/Acao/${acaoId}/Finalizar`, { texto: comentario })
      .then(res => {
        ObterPDIs()
        onCloseModalFinalizarAcao()
      })
      .catch(err => console.log(err))
  }

  useEffect(() => {
    ObterPDIs()
  }, [])

  return (
    <Body isLoading={IsLoading}>
      <ModalVisualizarComentarios
        isOpen={ModalVisualizarIsOpen}
        onRequestClose={onCloseModalVisualizarComentario}
        acao={Acao?.acao}

      />

      <ModalFinalizarAcao
        isOpen={ModalFinalizarAcaoIsOpen}
        onRequestClose={onCloseModalFinalizarAcao}
        FinalizarAcao={FinalizarAcao}
        id={Acao?.pdiId as string}
        acao={Acao?.acao}
      />

      <WhiteBox>
        <Flex justifyContent={'space-between'} marginBottom='1rem'>
          <h1>Desempenho {'>'} PDI</h1>
          {
            (Model && (Model?.pdIs?.length > 0 || Model?.tabela?.length > 0)) && (
              <Button
                onClick={() => nav('/Desempenho/PDI/Criar')}
                VarColor='Azul' size={'lg'}
              >Criar PDI</Button>
            )
          }
        </Flex>
          {
            (adm === 'True' || role === '1' || role === '2') && (
              <Flex alignItems={'center'} gap={'.5rem'} marginBottom='1rem'>
                <Text
                  color={pathname.includes('Individual') ? 'var(--Azul)' : ''}
                  fontWeight={'medium'}>Visão individual
                </Text>
                <Switch
                    size={'md'}
                    onChange={(e) => e.target.checked ? nav('/Desempenho/PDI/Dashboard/Corporativo') : nav('/Desempenho/PDI/Dashboard/Individual')}
                    isChecked={pathname.includes('Corporativo')}
                />
                <Text
                  color={pathname.includes('Corporativo') ? 'var(--Azul)' : ''}
                  fontWeight={'medium'}
                >Visão corporativa</Text>
              </Flex>
            )
          }

        {
          (!IsLoading && (Model === undefined || (Model?.pdIs.length === 0 && Model?.tabela.length === 0))) && (
            <Flex flexDir={'column'} gap='1rem'>
              <Flex alignItems={'center'} color={'var(--Azul)'} justifyContent={'center'}>
                <Image className='sah_Img' height={'20rem'} src='https://sigah.blob.core.windows.net/onboard/bbb6990f-d313-488a-af99-5383c9bd1c82.png' />
                <h3>Ainda não há PDI atribuído a você!<br /> O que acha de criar o seu Plano de Desenvolvimento, agora?</h3>
              </Flex>
              <Flex justifyContent={'center'}>
                <Button
                  width={'fit-content'}
                  onClick={() => nav('/Desempenho/PDI/Criar')}
                  VarColor='Azul' size={'lg'}
                >Criar PDI</Button>
              </Flex>
            </Flex>
          )
        }

        {
          (Model && Model?.tabela.length > 0) && (
            <OutlineContainer theme={'Azul'}>
              <Tabela dados={Model?.tabela} slice={3} />
            </OutlineContainer>
          )
        }

        {
          (Model && Model?.pdIs.length > 0) && (
            <Flex flexDir={'column'} marginTop='1rem' gap={'1rem'}>
              <Text fontWeight={'700'} color='var(--Gray1)' fontSize={'1.375rem'}>Ações do PDI</Text>
              {
                Model?.pdIs.map((e, i) => {
                  return (
                    <OutlineContainer key={i} theme={'Azul'}>
                      <Flex marginBottom={'1rem'} justifyContent={'space-between'}>
                        <Text fontWeight={'700'} color='var(--Gray1)' fontSize={'1.375rem'}>{e.origem}</Text>
                        <Button VarColor='Azul' leftIcon={<FaPen />} onClick={() => nav(`/Desempenho/PDI/Editar/${e.id}`)}>Editar PDI</Button>
                      </Flex>
                      <Grid gap={'1rem'} templateColumns='repeat(3, 1fr)'>
                        {
                          e.acoes.map((a, i2) => {
                            return (
                              <AcaoCard
                                key={i2}
                                onOpenComentario={onOpenModalVisualizarComentario}
                                onOpenFinalizar={onOpenModalFinalizarAcao}
                                acao={a}
                                pdiId={e.id}
                              />
                            )
                          })
                        }
                      </Grid>
                    </OutlineContainer>
                  )
                })
              }
            </Flex>
          )
        }
      </WhiteBox>
    </Body>
  )
}
